import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';

import { PedidoReferenciaDataPipe } from './pedido-referencia-data.pipe';
import { PedidoReferenciaDataIconPipe } from './pedido-referencia-data-icon.pipe';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        PedidoReferenciaDataPipe,
        PedidoReferenciaDataIconPipe
    ],
    exports: [
        PedidoReferenciaDataPipe,
        PedidoReferenciaDataIconPipe
    ],
    providers: [
        PedidoReferenciaDataPipe,
        PedidoReferenciaDataIconPipe
    ]
})
export class PedidoReferenciaDataPipeModule { }
